
import { Button } from "@/components/ui/button";
import { InfoIcon } from "lucide-react";
import type { LogicRule } from "@/lib/logic-rules";

interface LogicRuleCardProps {
  rule: LogicRule;
  onReasoningClick?: () => void;
  onClick?: () => void;
}

export function LogicRuleCard({ rule, onReasoningClick, onClick }: LogicRuleCardProps) {
  if (!rule) {
    console.error("LogicRuleCard received undefined rule");
    return null;
  }
  
  console.log("LogicRuleCard rendering with:", {
    ruleName: rule.name,
    spectrum: rule.spectrum ? rule.spectrum.join(' to ') : 'None',
    hasSpectrum: !!rule.spectrum
  });

  return (
    <div className="card-container relative">
      <div 
        className={`card-base logic-card bg-black text-white ${onClick ? 'cursor-pointer' : ''}`}
        onClick={onClick}
      >
        <div className="flex flex-col items-center justify-center w-full px-2 relative h-full">
          <h3 className="text-lg font-bold mb-1">
            {rule.name}
          </h3>
          
          {rule.spectrum && rule.spectrum[0] && rule.spectrum[1] && (
            <div className="logic-rule-spectrum-labels">
              <span>{rule.spectrum[0]}</span>
              <span className="logic-rule-spectrum-separator mx-1"><i>to</i></span>
              <span>{rule.spectrum[1]}</span>
            </div>
          )}
          
          {onReasoningClick && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="absolute bottom-0 right-0 m-0.5 p-1 h-auto rounded-full text-gray-300 hover:text-white hover:bg-gray-700"
              onClick={(e) => {
                e.stopPropagation(); // Prevent card click from triggering
                onReasoningClick();
              }}
              aria-label="Show reasoning"
            >
              <InfoIcon size={18} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
